import { useEffect, useRef } from "react"

/*
  helper hook used to return a ref from a state value,
  useful for usage within event callbacks, that do not
  use updated state values
  value: the dependency and return value of the ref, if no transformValue is provided
  initValue: if the value initializes on a different value than the dependency
  transformValue: if provided, overrides the ref return value
 */
export const useHelper = <T, R = T>(
  value: T,
  initValue?: T,
  transformValue?: R,
) => {
  const ref = useRef<T | R>(initValue ?? value)

  useEffect(() => {
    ref.current = transformValue ?? value
  }, [value])

  return ref
}
